import React from 'react';
import NavDropdownHover from '../mainMenu/NavDropdownHover';
import { NavItem } from 'react-bootstrap';
import FontAwesome from 'react-fontawesome';
import { withNamespaces } from 'react-i18next';

const LanguageMenu = ({ isMobileMenu, languages, activeLanguage, onSelectLanguage, t }) => {
    const renderTitle = isMobileMenu ? <span> {t('FO_MainMenu_Language')} <FontAwesome name='angle-down' /> </span> :
        <span>
            <img src={activeLanguage ? require(`../../theme/images/lang/${activeLanguage.image}`) : ''} /> <FontAwesome name='angle-down' />
        </span>;

    return <NavDropdownHover id='languageMenu' key='languageMenu' openOnHover={!isMobileMenu}
        title={activeLanguage && renderTitle} >
        {languages.map((language) =>
            <NavItem key={language.id} onClick={() => onSelectLanguage(language.culture)}>
                <img src={require(`../../theme/images/lang/${language.image}`)} alt={language.image} />
                <span className={activeLanguage && language.id !== activeLanguage.id ? 'text-muted' : ''}>{language.name}</span>
            </NavItem>
        )}
    </NavDropdownHover>;
};

export default withNamespaces()(LanguageMenu);